var map = {
	"./de_DE.json": 1024,
	"./en_AU.json": 1025,
	"./en_CA.json": 1026,
	"./en_GB.json": 1027,
	"./es_AR.json": 1028,
	"./es_ES.json": 1029,
	"./es_MX.json": 1030,
	"./fr_CA.json": 1031,
	"./fr_FR.json": 1032,
	"./it_IT.json": 1033,
	"./nl_NL.json": 1034,
	"./pt_BR.json": 1035,
	"./pt_PT.json": 1036
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1023;